import AccordianDividerComponent from './AccordionDividerComponent';
export * from './AccordionDividerComponent';
export default AccordianDividerComponent;
